import { apiPharmaInstance } from 'utils/axios';

// Post
export const postDrugManufacturersOnOff = async (pointOfSaleId, payload) => {
    return await apiPharmaInstance.post(`/api/points-of-sale/${pointOfSaleId}/drug-manufacturer-switch`, {
        ...payload,
    });
};
